import api from './kernelApi';

// Chiamate API comuni a tutti i moduli (auth, utenti, ruoli, menu, aziende, audit).
// I moduli le riesportano con `export * from './kernelApiCommon'` e aggiungono le proprie.

export const login = async (email, password) => {
  const response = await api.post('/auth/login', { email, password });
  return response.data;
};

export const verifyLoginOtp = async (email, otp) => {
  const response = await api.post('/auth/login/verify-otp', { email, otp });
  return response.data;
};

export const getMe = async () => {
  const response = await api.get('/auth/me');
  return response.data;
};

export const updateProfile = async (data) => {
  const response = await api.put('/auth/profile', data);
  return response.data;
};

export const changePassword = async (current_password, new_password) => {
  const response = await api.post('/auth/change-password', { current_password, new_password });
  return response.data;
};

export const getUsers = async (includeInactive = false) => {
  const params = includeInactive ? { include_inactive: 1 } : {};
  const response = await api.get('/users', { params });
  return response.data;
};

export const createUser = async (data) => {
  const response = await api.post('/users', data);
  return response.data;
};

export const updateUser = async (id, data) => {
  const response = await api.put(`/users/${id}`, data);
  return response.data;
};

export const deleteUser = async (id) => {
  const response = await api.delete(`/users/${id}`);
  return response.data;
};

export const reactivateUser = async (id) => {
  const response = await api.post(`/users/${id}/reactivate`);
  return response.data;
};

export const getRoles = async () => {
  const response = await api.get('/roles');
  return response.data;
};

export const updateRoleActions = async (roleId, actions) => {
  const response = await api.put(`/roles/${roleId}/actions`, { actions });
  return response.data;
};

export const getMenuConfig = async () => {
  const response = await api.get('/menu');
  return response.data;
};

export const updateRoleMenu = async (roleId, itemKeys, sectionOrder) => {
  const body = { item_keys: itemKeys };
  if (Array.isArray(sectionOrder)) body.section_order = sectionOrder;
  const response = await api.put(`/roles/${roleId}/menu`, body);
  return response.data;
};

export const getCompanies = async () => {
  const response = await api.get('/companies');
  return response.data;
};

export const createCompany = async (data) => {
  const response = await api.post('/companies', data);
  return response.data;
};

export const updateCompany = async (id, data) => {
  const response = await api.put(`/companies/${id}`, data);
  return response.data;
};

export const deleteCompany = async (id) => {
  const response = await api.delete(`/companies/${id}`);
  return response.data;
};

export const uploadCompanyLogo = async (id, file, hideName = false) => {
  const formData = new FormData();
  formData.append('logo', file);
  formData.append('hide_agency_name', hideName ? '1' : '0');
  const response = await api.post(`/companies/${id}/logo`, formData, {
    headers: { 'Content-Type': undefined },
  });
  return response.data;
};

export const deleteCompanyLogo = async (id) => {
  const response = await api.delete(`/companies/${id}/logo`);
  return response.data;
};

export const getAuditLogs = async (params = {}) => {
  const response = await api.get('/audit-logs', { params });
  return response.data;
};
